import { initCarousel, initCarouselActions, resetCarousel } from "../../../js/components/carousel";

const sustainabilityPillars = document.querySelectorAll('.sustainability-pillars__item');
const sustainabilityTabs = document.querySelectorAll('.pillar-tab');

export const sustainabilityPillar = () => {

  sustainabilityPillars.forEach((pillar, index) => {
    initCarousel(pillar, index === 0);
    initCarouselActions(pillar);
  });

  sustainabilityTabs.forEach((tab) => {
    tab.addEventListener('click', tabClickHandler);
  });

  window.addEventListener('resize', () => {
    resetCarousel(sustainabilityPillars);
  });
}

const tabClickHandler = (e) => {
  e.preventDefault();
  const target = e.currentTarget;
  const targetId = target.getAttribute('data-target');
  const targetContent = document.querySelector(`.sustainability-pillars__item.${targetId}`);

  console.log('clicked', target, targetId, targetContent);

  sustainabilityTabs.forEach((tab) => {
    tab.classList.remove('active');
  });

  sustainabilityPillars.forEach((pillar) => {
    pillar.classList.remove('active');
    pillar.style.display = 'none';
  });

  target.classList.add('active');
  targetContent.classList.add('active');
}



// WEBPACK FOOTER //
// ./src/templates/components/sustainability-pillar/sustainability-pillar.js